import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { requerido, numero } from './Validaciones'

import { cookieData } from '../funciones/ConsultaUser';

export const ConsultCarreras = (respuesta) => {
    Post(`${Url}consultCarreras`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].carrera_name }
            )
        }
        respuesta(contenido)
    });
}

export const ConsultaSemestres = (id, respuesta) => {
    let Content = {
        id: id,
    }
    Post(`${Url}consultSemestresDir`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let semestres = data1[1]
        let contenido= [];
        let materias= [];

        for (let i in data) {
            contenido.push(
                { id: data[i].id, nombre: data[i].semestre_name }
            )
        }

        for (let i in semestres) {
            let semestre = semestres[i]

            for (let n in semestre) {

                let materiasInd = semestre[n]
                for (let x in materiasInd) {
                    materias.push(
                        {
                            semestre: parseInt(i) + 1,
                            id: materiasInd[x].materia.id,
                            codigo: materiasInd[x].materia.codigo,
                            nombre: materiasInd[x].materia.materia_name,
                            prelacion1: materiasInd[x].materia.prelacion_1,
                            prelacion2: materiasInd[x].materia.prelacion_2,
                            horas: materiasInd[x].materia.horas,
                            uc: materiasInd[x].materia.u_c
                        }
                    )

                }
            }
        }

        respuesta([contenido, materias])
    });
}

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorCarrera.value, "", "", "", "Debes seleccionar primero una Carrera de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Semestre o Periodo Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.num.text, "", "", "", "El Número del Semestre o Periodo Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.num.text, "", "", "El campo Número del Semestre o Periodo debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addSemestre`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente el semestre"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const verSemestre = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verSemestre`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].semestre_name, status: "" },
                num:  { text: data[0].semestre_num, status: "" },
                preloaderSem:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
                openDelSem: false,
            }

            respuesta (state) 
        });
    });
}

export const Delete = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delSemestre`, Content, (resp) => {
            respuesta (resp)
        });
    });
}

export  const Editar = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorCarrera.value, "", "", "", "Debes seleccionar primero una Carrera de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Semestre o Periodo Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.num.text, "", "", "", "El Número del Semestre o Periodo Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.num.text, "", "", "El campo Número del Semestre o Periodo debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id: id
            }

            Post(`${Url}editSemestre`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha modificado correctamente el semestre"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}



// WEBPACK FOOTER //
// ./src/funciones/ModalidadesFunction.jsx